<template>
    <!--Waiting List Enrollment Step One-->
    <div class="enroll-info-screen">
        <div class="enroll-wrapper">
            <h6 class="sub-title">{{ $ml.get("waitingListEnroll.subTitle") }}</h6>
            <div class="steps">
                <p class="highlight-text">{{ $ml.get("waitingListEnroll.step1") }}</p>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <div class="steps">
                <p class="highlight-text">{{ $ml.get("waitingListEnroll.step2") }}</p>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <p class="highlight-text">{{ $ml.get("waitingListEnroll.step3") }}</p>
            <div class="enroll-wrapper enroll-step-three">
                <p>
                    {{ $ml.get("waitingListEnroll.stepThreeP") }}
                </p>
                <div class="checkbox-inputs-container">
                    <!--SMS-->
                    <div class="input-checkbox">
                        <div class="input-box">
                            <input
                                v-model="sms"
                                type="checkbox"
                                id="sms-checkbox"
                                name="SMS"
                                value="sms"
                                @change="updateNotificationPreferences"
                            />
                        </div>
                        <label for="sms-checkbox" class="checkbox-label-wrap" type="button">
                            <span class="checkbox-title">
                                Text Messages ({{ profileCurrency }}{{ costPerSms }} per 100 SMS)
                            </span>
                        </label>
                        <i
                            class="fa fa-info-circle"
                            aria-hidden="true"
                            data-toggle="modal"
                            data-target="#textMessagesMoreInfo"
                        ></i>
                    </div>
                    <!--Emails-->
                    <div class="input-checkbox">
                        <div class="input-box">
                            <input
                                v-model="email"
                                type="checkbox"
                                id="email-checkbox"
                                name="Email"
                                value="email"
                                @change="updateNotificationPreferences"
                            />
                        </div>
                        <label for="email-checkbox" class="checkbox-label-wrap" type="button">
                            <span class="checkbox-title"
                                >Emails ({{ profileCurrency }}{{ costPerEmail }} per 1000 Emails)
                            </span>
                        </label>
                        <i
                            class="fa fa-info-circle"
                            aria-hidden="true"
                            data-toggle="modal"
                            data-target="#emailMoreInfo"
                        ></i>
                    </div>
                    <!--Push-->
                    <div class="input-checkbox">
                        <div class="input-box">
                            <input
                                v-model="push"
                                type="checkbox"
                                id="push-checkbox"
                                name="Push"
                                value="push"
                                @change="updateNotificationPreferences"
                            />
                        </div>
                        <label for="push-checkbox" class="checkbox-label-wrap">
                            <span class="checkbox-title">In App Push Notifications (free)</span>
                        </label>
                    </div>
                    <!--All of the above-->
                    <div class="input-checkbox">
                        <div class="input-box">
                            <input
                                v-model="all"
                                type="checkbox"
                                id="all-checkbox"
                                name="All"
                                value="all"
                                @change="updateNotificationPreferences"
                            />
                        </div>
                        <label for="all-checkbox" class="checkbox-label-wrap">
                            <span class="checkbox-title">All of the above</span>
                        </label>
                    </div>
                    <div class="next-step">
                        <button
                            @click="saveNotificationPreferences"
                            :class="selectedNotifications.length == 0 ? 'disabled-button' : ''"
                            class="primary-btn extra-small mobile"
                        >
                            Continue
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!--SMS modal-->
        <waiting-list-modal
            id="textMessagesMoreInfo"
            title="Text Messages (SMS)"
            p1="To ensure your clients receive instant alerts about available spots, we highly recommend text message notifications."
            :p2="`Text message notifications are available in packs of 100 messages for ${profileCurrency}${costPerPackMethod(
                costPerSms,
                100
            )} (100 messages x ${profileCurrency}${costPerSms}
            /message).`"
            buttonText="Got it"
        >
        </waiting-list-modal>
        <!--Email modal-->
        <waiting-list-modal
            id="emailMoreInfo"
            title="Emails"
            p1="To ensure your clients receive timely alerts about available spots, email notifications are available."
            :p2="`Email notifications are sold in packs of 1,000 emails for ${profileCurrency}${costPerPackMethod(
                costPerEmail,
                1000
            )}
             (1,000 emails x ${profileCurrency}${costPerEmail} per email).`"
            buttonText="Got it"
        >
        </waiting-list-modal>
    </div>
</template>

<script>
import store from "../../../../services/vuex";
import eventBus from "../../../../services/event_bus";
import WaitingListModal from "../parts/waiting_list_modal.vue";
import api from "../../../../services/api_endpoints";

export default {
    data() {
        return {
            profile: {},
            enrollmentCost: 1,
            sms: false,
            email: false,
            push: false,
            all: false,
            profileCurrency: "$",
            costPerSms: 0,
            costPerEmail: 0,
            costPerPack: 0,
            smsAllowedCountries: [],
            selectedNotifications: [],
        };
    },
    computed: {
        adminDetails: {
            get: function () {
                return store.state.adminDetails;
            },
            set: function (value) {
                store.commit("setAdminDetails", value);
            },
        },
    },
    mounted() {
        //check if adminDetails are either in store or loaded
        //if yes then do necessary logic
        this.smsAllowedCountries = process.env.VUE_APP_SMS_ALLOWED_COUNTRIES.split(",");
        if (store.state.adminDetails.user) {
            this.onAdminDetailsLoad();
        }
        let self = this;
        eventBus.$on("admin_details_loaded", function () {
            self.onAdminDetailsLoad();
        });

        this.enrollmentCost = process.env["VUE_APP_ENROLLMENT_COST"];

        this.updateNotificationPreferences();
    },
    components: { WaitingListModal },
    methods: {
        changeScreen(screen) {
            this.$emit("change-screen", screen);
        },

        getStylistProfile() {
            this.profile = this.adminDetails.profile;
        },

        onAdminDetailsLoad: function () {
            if (this.smsAllowedCountries.indexOf(this.adminDetails.profile.country_id.toString()) > -1) {
                this.costPerSms = process.env["VUE_APP_SMS_COST_" + this.adminDetails.profile.country_id];
            } else {
                this.costPerSms = process.env["VUE_APP_SMS_COST_0"];
            }

            this.costPerEmail = parseFloat(process.env["VUE_APP_EMAIL_COST"]);
            this.getStylistProfile();
        },

        costPerPackMethod(msgType, pack) {
            return this.costPerPack = (msgType * pack).toFixed(2);
        },
        updateNotificationPreferences() {
            // Reset the array each time the method is called
            this.selectedNotifications = [];

            // Check each option and push the corresponding value to the array
            if (this.sms) {
                this.selectedNotifications.push("sms");
            }
            if (this.email) {
                this.selectedNotifications.push("email");
            }
            if (this.push) {
                this.selectedNotifications.push("push");
            }
            if (this.all) {
                this.selectedNotifications = [];
                this.sms = true;
                this.email = true;
                this.push = true;
                this.selectedNotifications.push("sms", "email", "push");
            }

            if (!this.all && !this.sms && !this.email && !this.push) {
                this.selectedNotifications = [];
            }
        },
        saveNotificationPreferences() {
            let data = {
                type: "stylist",
                sms: this.selectedNotifications.indexOf("sms") != -1 ? 1 : 0,
                email: this.selectedNotifications.indexOf("email") != -1 ? 1 : 0,
                push: this.selectedNotifications.indexOf("push") != -1 ? 1 : 0,
            };

            this.$http.post(api.actions.save_waiting_list_settings, data).then((response) => {
                if (response.data.error == true) {
                    return;
                }

                this.changeScreen("enroll-step-four");
                eventBus.$emit("reload_user_details");
            });
            return;
        },
    },
};
</script>
